import baseColors from "tailwindcss/colors"
import { theme } from "frappe-ui/src/utils/tailwind.config"
const colors = theme.colors({ colors: baseColors })

export function getLightnessScale(variant: string, color: string) {
  const out = _getLightnessScale(variant)
  if (color == "black" && variant != "text" && variant != "ghost") {
    out.bg.active = 900
    out.bg.base = 999
    out.bg.hover = 700
    out.text.active = 0
    out.text.base = 0
    out.text.hover = 0
  } else if (color == "white" && variant != "text" && variant != "ghost") {
    out.bg.active = 200
    out.bg.base = 0
    out.bg.hover = 100
    out.text.active = 999
    out.text.base = 999
    out.text.hover = 999
  }
  return out
}

function _getLightnessScale(variant: string) {
  if (variant === "solid") {
    return {
      bg: { base: 700, hover: 600, active: 800 },
      text: { base: 0, hover: 0, active: 0 },
    }
  } else if (variant === "soft") {
    return {
      bg: { base: 200, hover: 300, active: 200 },
      text: { base: 800, hover: 900, active: 900 },
    }
  } else if (variant === "outline") {
    return {
      bg: { base: -1, hover: 100, active: 200 },
      text: { base: 800, hover: 900, active: 900 },
    }
  } else if (variant === "ghost") {
    return {
      bg: { base: -1, hover: 300, active: 200 },
      text: { base: 800, hover: 900, active: 900 },
    }
  } else if (variant === "text") {
    return {
      bg: { base: -1, hover: -1, active: -1 },
      text: { base: 800, hover: 900, active: 900 },
    }
  }
  throw Error("getLightnessScale: invalid `variant`")
}

export function getColor(color: string, scale: number) {
  if (scale === -1) {
    return "transparent"
  } else if (scale === 0) {
    return colors.white
  } else if (scale >= 999) {
    return colors.black
  } else if (color === "white" || color === "black") {
    return `hsl(0,0%,${Math.round(100 - (scale / 9))}%)`
  } else if (color === "primary") {
    if (scale > 400) {
      return "var(--theme-primary)"
    } else {
      const f = (x) => x / 2
      const p = Math.round(100 * f(scale / 900))
      return `color-mix(in srgb, var(--theme-primary) ${p}%, #fff)`
    }
  }
  return colors?.[color]?.[scale] ?? "gray"
}
